var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { staticStyle: { padding: "40px" }, attrs: { span: 24 } }, [
        _c(
          "div",
          {
            staticStyle: {
              border: "4px solid #cccccc",
              "border-radius": "30px",
              padding: "20px"
            }
          },
          [
            _c("el-row", [_c("el-col", { attrs: { span: 24 } })], 1),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { staticClass: "center-col", attrs: { span: 24 } },
                  [
                    _c("span", { staticClass: "title-property-selection" }, [
                      _vm._v("Select your new property")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticClass: "center-col",
                    staticStyle: { "margin-top": "24px" },
                    attrs: { span: 24 }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "para-property-selection",
                        staticStyle: { "font-weight": "bold" }
                      },
                      [
                        _vm._v(
                          "\n            Complete your Reservation\n          "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticClass: "center-col",
                    staticStyle: { "margin-top": "10px" },
                    attrs: { span: 24 }
                  },
                  [
                    _c("span", { staticClass: "para-property-selection" }, [
                      _vm._v(
                        "\n            Take advantage of UNIFI Property's unique online reservation function to reserve this property\n          "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticClass: "center-col",
                    staticStyle: { "margin-top": "10px" },
                    attrs: { span: 24 }
                  },
                  [
                    _c("span", { staticClass: "para-property-selection" }, [
                      _vm._v(
                        "exclusively for your client for the next 7 days.\n          "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticClass: "center-col",
                    staticStyle: { "margin-top": "24px" },
                    attrs: { span: 24 }
                  },
                  [
                    _c("span", { staticClass: "para-property-selection" }, [
                      _vm._v(
                        "\n            The UNIFI Property Concierge will be in contact with yourself and the vendor to progress the sale.\n          "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticClass: "center-col",
                    staticStyle: { "margin-top": "24px" },
                    attrs: { span: 24 }
                  },
                  [
                    _c("span", { staticClass: "para-property-selection" }, [
                      _vm._v(
                        "\n            To start the process, select which of the available properties your client would like to reserve.\n          "
                      )
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { offset: 6, span: 4 } }, [
                  _c("span", { staticClass: "label-available full-width" }, [
                    _vm._v("Available properties")
                  ])
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 4 } }, [
                  _c("span", { staticClass: "label-sold full-width" }, [
                    _vm._v("Sold properties")
                  ])
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 4 } }, [
                  _c("span", { staticClass: "label-reserved full-width" }, [
                    _vm._v("Reserved properties")
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              {
                staticStyle: {
                  "margin-top": "40px",
                  display: "flex",
                  "justify-content": "center",
                  "flex-wrap": "wrap"
                },
                attrs: { gutter: 20 }
              },
              _vm._l(_vm.datum, function(item, index) {
                return _c(
                  "el-col",
                  { key: index, staticClass: "prop-tile", attrs: { span: 4 } },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "btn-prop-res": true,
                          reserved: item.status == "Reserved",
                          sold:
                            item.status == "Sold" ||
                            item.status == "Unconditional" ||
                            item.status == "Settled",
                          available: item.status == "Available",
                          choosed: index == _vm.cur
                        },
                        on: {
                          click: function($event) {
                            return _vm.choosed(index, item.roomId, item.status)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(item.apt) + "\n          "
                        )
                      ]
                    )
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-end"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        class: {
                          "selection-continue disabled":
                            _vm.datum.length === 0 || _vm.cur === -1,
                          "selection-continue":
                            _vm.datum.length > 0 && _vm.cur !== -1
                        },
                        attrs: {
                          disabled: _vm.datum.length === 0 || _vm.cur === -1
                        },
                        on: { click: _vm.reservePropertyForm }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.buyNowOrMakeOfferBtn) + "\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b4fe99f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b4fe99f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uConnectReservation/propertySelection.vue
// module id = null
// module chunks = 